import { colors, ThemeName, tokenNames } from "./colors";
import { toCssVarName } from "./cssVarName";

export const themeStyles = (theme: ThemeName): string => {
  const body = tokenNames
    .map((t) => `  --${toCssVarName(t)}: ${colors[theme][t]};`)
    .join("\n");
  return `[data-theme="${theme}"] {\n${body}\n}`;
};
